import "./subwidget.css";

import ActiveSubTimWe from "./ActiveSubTimWE";

import CountSubUnSubDailyVibe from "./CountSubUnSubDailyVibe";
import NotificationByCompany from "./notificationByCompany";
import PinApiPostedVibe from "./PinApiPostedVibe";

const SubWidgetVibeSA = ({ table, role }) => {
    const colors = ["red", "green", "blue", "brown"];
    const randomIndex = Math.floor(Math.random() * colors.length);
    const randomColor = colors[randomIndex];


    return (
        <div
            className="col-10 "
            style={{
                position: "relative",
                left: "250px",
                top: "100px",
            }}
        >
            <div className="row  p-3">
                {role !== "accountant" && (
                    <>
                        <div className="row justify-content-center">
                            <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    Daily Report AE{" "}
                                    <span style={{ color: randomColor }}>
                                        {/* {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : ( */}
                                        <>Vibelytics DU</>
                                        {/* )} */}
                                    </span>
                                </h2>
                                <div>
                                    <CountSubUnSubDailyVibe table={table + "/countSubUnSubAE"} />
                                </div>
                            </div>

                            <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    ActiveSub AE {" "}
                                    <span style={{ color: randomColor }}>
                                        {/* {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : ( */}
                                        <>Vibelytics</>
                                        {/* )} */}
                                    </span>
                                </h2>
                                <div>
                                    <ActiveSubTimWe table={table + "/AEDU"} />
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-8 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    Billing {" "}
                                    <span style={{ color: randomColor }}>
                                        {/* {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : ( */}
                                        <>Vibelytics DU</>
                                        {/* )} */}
                                    </span>
                                </h2>
                                <div>
                                    <NotificationByCompany table={table} />
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-8 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    Posted AE {" "}
                                    <span style={{ color: randomColor }}>
                                        {/* {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : ( */}
                                        <>Vibelytics</>
                                        {/* )} */}
                                    </span>
                                </h2>
                                <div>
                                    <PinApiPostedVibe table={table + "/getPinAPIPosted"} />
                                </div>
                            </div>

                            {/* <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    Billable Posted SA {" "}
                                    <span style={{ color: randomColor }}>
                                        {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : (
                                            <>Vibelytics</>
                                        )}
                                    </span>
                                </h2>
                                <div>
                                    <PinApiPostedVibe table={table + "/getS2SPostedBillable"} />
                                </div>
                            </div> */}
                        </div>

                    </>
                )}

            </div>
        </div >
    );
};

export default SubWidgetVibeSA;
